module.exports = __webpack_public_path__ + "img/upload-dropzone.586f9a3d.svg";